import React, { useState } from "react";
import Item from "./Item";
import "./services.css";

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What i offer </span>

      <div className="services__container container grid">
        <div className="services__content">
          <div>
            <i className="uil uil-web-grid  services__icon"></i>
            <h3 className="services__title">
              Web <br /> Design
            </h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(1)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>{" "}
          </span>

          <div
            className={
              toggleState === 1
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>

              <h3 className="services__modal--title">Web Design</h3>

              <ul className="services__modal-services grid">
                <Item text="Proficiency in graphic design tools like Adobe Photoshop, Illustrator, or Sketch" />
                <Item text="Knowledge of typography and color theory" />
                <Item text="Understanding of user experience design principles" />
                <Item text="Proficiency in HTML and CSS for creating responsive web designs" />
                <Item text="Understanding of web standards and accessibility guidelines" />
              </ul>
            </div>
          </div>
        </div>

        {/* Second Services Content */}
        <div className="services__content">
          <div>
            <i className="uil uil-arrow services__icon"></i>
            <h3 className="services__title">
              Frontend <br /> Development
            </h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(2)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div
            className={
              toggleState === 2
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>

              <h3 className="services__modal--title">Frontend Development</h3>

              <ul className="services__modal-services grid">
                <Item text="Proficiency in HTML, CSS, and JavaScript." />
                <Item text="Experience with frontend frameworks and libraries like React." />
                <Item text="Understanding of UX/UI design principles." />
                <Item text="Knowledge of web performance optimization." />
                <Item text="Understanding of cross-browser compatibility issues." />
                <Item text="Understanding of UX/UI design principles." />
              </ul>
            </div>
          </div>
        </div>

        {/* Third Services Content */}
        <div className="services__content">
          <div>
            <i className="uil uil-edit services__icon"></i>
            <h3 className="services__title">
              Backend <br /> Development
            </h3>
          </div>

          <span className="services__button" onClick={() => toggleTab(3)}>
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>{" "}
          </span>

          <div
            className={
              toggleState === 3
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>

              <h3 className="services__modal--title">Backend Development</h3>

              <ul className="services__modal-services grid">
                <Item text="Proficiency in a backend programming language like Python" />
                <Item text="Understanding of database management and proficiency in using SQL or NoSQL databases" />
                <Item text="Familiarity with server-side frameworks like Django, Node.js" />
                <Item text="Knowledge of web APIs and web services like RESTful APIs" />
                <Item text="Experience with version control systems like Git and code repositories like GitHub" />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
